import React from "react";
import { IEventData, IGalleryImageData } from "../../exports/interfaces";
import { Link } from "react-router-dom";
import { formatDateDetails } from "../../exports/functions";
import { useLoader } from "../../context/LoaderContext";
import { Fade } from "react-awesome-reveal";
import DynamicToolTip from "../DynamicToolTip";

const Album = (props: {
  galleryImageData: IGalleryImageData[];
  eventData: IEventData[];
}) => {
  const { loading } = useLoader();

  const galleryAlbums =
    props?.galleryImageData?.map((event) => ({
      ...event,
      attributes: {
        ...event,
        Data_Category: "gallery",
        Date: event?.date,
        Thumbnail: event?.thumbnail,
        Title: event?.title,
      },
    })) || [];

  const eventAlbums =
    props?.eventData
      ?.filter((event) => event?.images !== null)
      ?.map((event) => ({
        ...event,
        attributes: {
          ...event,
          Thumbnail: event?.image,
          Title: event?.event_name,
          Date: event?.from_date,
          Data_Category: "event",
        },
      })) || [];

  const combineAlbum = [...galleryAlbums, ...eventAlbums];
  const album = combineAlbum
    ?.sort(
      (a, b) =>
        new Date(b?.attributes?.Date).getTime() -
        new Date(a?.attributes?.Date).getTime(),
    )
    ?.map((event) => ({
      ...event,
      attributes: {
        ...event.attributes,
        ...formatDateDetails(event?.attributes?.Date),
      },
    }));

  return (
    // <section className="events-page">
    //   <div className="container">
    //     <div className="row">
    //       {props?.galleryImageData?.map((image) => (
    //         <div className="col-xl-3 col-lg-6 col-md-6">
    //           <div className="events__single">
    //             <div className="events__img">
    //               <img
    //                 src={`${process.env.REACT_APP_strapiUrl}${image?.attributes?.Thumbnail?.data?.attributes?.url}`}
    //                 alt="album-image"
    //                 height="255"
    //               />
    //               {/* <div className="events__date">
    //                     <p>{event?.attributes?.Date}</p>
    //                   </div> */}
    //             </div>
    //             <div className="events__content">
    //               <h3 className="events__title">
    //                 {/* <Link
    //                       to="/events/events-details"
    //                       state={{
    //                         id: event.id,
    //                         bannerUrl: props?.eventBannerImage
    //                       }}
    //                     > */}
    //                 {image?.attributes?.Title}
    //                 {/* </Link> */}
    //               </h3>
    //               {/* <ul className="list-unstyled events__meta"> */}
    //               {/* <li>
    //                       <i className="far fa-clock"></i>
    //                       {event?.attributes?.Time}
    //                     </li>
    //                     <li>
    //                       <i className="fas fa-map-marker-alt"></i>
    //                       {event?.attributes?.Event_Location}
    //                     </li> */}
    //               <div className="custom-newsletter-button">
    //                 <Link
    //                   to="/gallery/gallery-view"
    //                   state={{
    //                     id: image.id,
    //                   }}
    //                   className="donate-btn main-header-two__btn custom-main-header-two__btn"
    //                 >
    //                   View Gallery
    //                 </Link>
    //               </div>
    //               {/* </ul> */}
    //             </div>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // </section>
    <section className="events-page custom-padding">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          {!loading &&
            album?.map((image, index) => (
              <div className="col-5th custom-margin-bottom" key={image.id}>
                <Fade
                  key={index}
                  cascade
                  damping={0.2}
                  triggerOnce={true}
                  delay={index * 200}
                >
                  <Link
                    to={`/gallery/gallery-view/${image.id}?category=${image.attributes.Data_Category}`}
                  >
                    <div className="events__single">
                      <div className="events__img">
                        <img
                          src={
                            image?.attributes?.Thumbnail[0]?.media?.url &&
                            `${process.env.REACT_APP_cmsUrl}${image?.attributes?.Thumbnail[0]?.media?.url}`
                          }
                          alt="album-image"
                          className="row-image"
                          style={{
                            objectFit: "cover",
                          }}
                        />
                        <div className="events__date">
                          <p>
                            {image?.attributes?.Date} <br />{" "}
                            {image?.attributes?.Month} <br />{" "}
                            {image?.attributes?.Year}
                          </p>
                        </div>
                      </div>
                      <div
                        className="events__content row-content"
                        // style={{ padding: "15px" }}
                      >
                        <h3
                          className="events__title custom-grid-font-size text-truncate"
                          style={{ marginBottom: "unset" }}
                        >
                          <DynamicToolTip title={image?.attributes?.Title}>
                            {image?.attributes?.Title}
                          </DynamicToolTip>
                        </h3>
                      </div>
                    </div>
                  </Link>
                </Fade>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Album;
